import * as React from "react"
import { Link } from "gatsby"
import { css } from "linaria" 
import cx from "classnames"

import logo from "../images/logo.png"
import Seo from "./seo"
import Counter from "./counter";

const cn = {
  wrapper: css`
    width: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  `,
  logo: css`
    width: 34rem;
    display: block;
    padding-top: 4rem;
    margin: 0 auto;
  `,
  footer: css`
    font-family: 'Righteous', cursive;
    margin: 2rem;
    color: #fff;
    text-align: center;
    padding-top: 5rem;
  `,
  nonRoot: css`
    width: 20rem;
    padding-top: 2rem;
    padding-bottom: 1.5rem;
  `,
  main: css`
    flex-grow: 1;
  `,
  link: css`
    display: block;
    border: none;
  `,
}

export const Layout = ({ location, title, description, children }) => {
  const rootPath = `${__PATH_PREFIX__}/`
  const isRootPath = location.pathname === rootPath
  const image = <img src={logo} className={cx(cn.logo, !isRootPath && cn.nonRoot)} alt="BlasterBeat" />
  const header = isRootPath
    ? image
    : <Link to="/" className={cn.link}>{image}</Link>;

  return (
    <div className={cn.wrapper}>
      <Counter />
      <Seo title={title} description={description} />
      {header}
      <main className={cn.main}>{children}</main>
      <footer className={cn.footer}>
        © {new Date().getFullYear()}, BlasterBeat
      </footer>
    </div>
  )
}

export default Layout
